import React, { useRef, useState } from "react";

import title from "../../../assets/images/title.png";

import { Box, Typography } from "@mui/material";

const BP1 = "@media (max-width: 1079px)";
const BP2 = "@media (max-width: 1480px) and (min-width:1199px)";

const sx = {
  root: {
    width: "100%",
    px: "20px",
  },
  content: {
    width: "100%",
    maxWidth: "460px",
    // pt: '24px',
    zIndex: "1",
    [BP1]: {
      pt: "40px",
    },
    [BP2]: {
      maxWidth: "70%",
      pt: 0,
    },
  },
  imgContainer: {
    position: "relative",
    width: "100%",
    maxWidth: "1073px",
    margin: "auto",
  },
  img: {
    height: "100%",
    width: "100%",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
  },
  textContainer: {
    margin: "auto",
  },
  inlineImg: {
    height: "30px",
  },
  description: {
    margin: "auto",
    maxWidth: "728px",
    textAlign: "center",
  },
};

const Banner = () => {
  return (
    <Box sx={sx.root}>
      <Box sx={sx.imgContainer}>
        <Box sx={sx.img} src={title} component="img"></Box>
      </Box>
      <Box sx={sx.textContainer}>
        <Typography variant="body1" sx={sx.description}>
          The fey realm and web3 have something in common: in both, a name
          confers power. In the fey, knowing someone’s name - their True Name -
          confers power over them, much as knowing someone’s private key does.
          The Equinox collection by ENS and Galaxis celebrates this connection,
          and the significance of names and identities in both worlds.
        </Typography>
        <br></br>
        <Box>
          <Typography variant="body1" sx={sx.description}>
            The Equinox collection consists of 12 unique NFTs issued monthly
            over a year, with the first to be released on the Spring Equinox.
            Each NFT celebrates a member of the Summer and Winter fey courts,
            and anyone who can collect all 12 NFTs will have the unique
            opportunity to forge them into a single NFT representing both courts
            and the entire year.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Banner;
